module.exports = __webpack_public_path__ + "img/ascend_gold41.40496509.png";